import useSWR from 'swr';
import { getAmastyProductsBySkus } from '@/services/elasticsearch/getProducts';
import { getProductsBySkusV2 } from '@/services/product';
import useCart from '@/store/cart.store';

const fetcher = (fn, ...args) => fn(...args);

const useRelatedProducts = (productSku, locale) => {
  const setRelatedProducts = useCart((state) => state.setRelatedProducts);

  const { data: amastyData, isLoading: isSkusLoading } = useSWR(
    productSku ? ['amasty', productSku] : null,
    () => fetcher(getAmastyProductsBySkus, productSku),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
    }
  );

  const relatedSkus =
    amastyData?.data?.data?.[0]?.related?.filter(Boolean) || [];

  const { isLoading } = useSWR(
    relatedSkus.length > 0
      ? ['relatedProducts', locale, relatedSkus.join(',')]
      : null,
    () => fetcher(getProductsBySkusV2, locale, relatedSkus, false),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      onSuccess: (res) => {
        const products = res?.data?.data?.products || [];
        if (products.length > 0) {
          const productsData = products.map((e) => ({
            _media_: e?._media_,
            innova_url: e?.innova_url,
            name: e?.name,
            prices_with_tax: e?.prices_with_tax,
            sku: e?.sku,
          }));
          setRelatedProducts(productsData);
        }
      },
    }
  );

  return { isLoading: isLoading || isSkusLoading };
};

export default useRelatedProducts;
